// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"51b9c56a","158":"4ae1b6e8","203":"02dded48","239":"2f822dd7","294":"1331e272","305":"d9f940ff","396":"8b9c8457","455":"ccda51f6","795":"dec7a3de","884":"f6c0969d","887":"e94210e1","977":"4288e1ed"}[chunkId] + ".chunk.js";
};